const DataVisualizationType = {
    HISTOGRAM: "histogram",
    BAR: "bar",
    PIE: "pie",
    MAP: "map",
    TABLE: "table",
    SECTION: "section"
};

export default DataVisualizationType;